import styled from 'styled-components';
import { COLOR_GREY } from '../../config';
import ListIcon from '../../assets/content/hexagon-list.svg';

export const ListItem =  styled.li`
position: relative;
padding: 0 0 0 1.5rem;
list-style: none;
color: ${COLOR_GREY};
font-size: 1rem;
margin-bottom: .5rem;

&:before {
    content: '';
    background: url(${ListIcon}) no-repeat left center;
    width: 0.5rem;
    height: 1.3rem;
    display: inline-block;
    background-size: contain;
    position: absolute;
    left: 0;
}
`;

